<app-layout>
<button id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#myModal">Open Modal</button>
  <div class="row">
    <div class="col-12">
      <table class="table table-striped">
        <tr>
          <th> Duyuru Başlığı </th>
          <th> Duyuru Tarihi </th>
          <th> Duyuru Bitiş Tarihi </th>
          <th> İncele </th>
        </tr>
        <tr *ngFor="let item of duyurular" style="cursor: pointer;" (click)="openModel(item)">
          <td *ngIf="!item.duyuruGoruldu.isGoruldu" style="background-color: #c9c9c9d9;" >{{item.duyuru.baslik}}</td>
          <td *ngIf="!item.duyuruGoruldu.isGoruldu" style="background-color: #c9c9c9d9;">{{item.duyuru.duyuruTarihi}}</td>
          <td *ngIf="!item.duyuruGoruldu.isGoruldu" style="background-color: #c9c9c9d9;">{{item.duyuru.duyuruBitisTarihi}}</td>

          <td *ngIf="item.duyuruGoruldu.isGoruldu" >{{item.duyuru.baslik}}</td>
          <td *ngIf="item.duyuruGoruldu.isGoruldu">{{item.duyuru.duyuruTarihi}}</td>
          <td *ngIf="item.duyuruGoruldu.isGoruldu">{{item.duyuru.duyuruBitisTarihi}}</td>

          
          <td> <button class="btn btn-sm btn-primary"> incele </button> </td>
        </tr>
      </table>
    </div>
  </div>


  <div id="modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalBaslik"></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" (click)="modalClose()">&times;</span>
          </button>
        </div>
        <div class="modal-body" id="modalBody">

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalClose()">Close</button>
        </div>
      </div>
    </div>
  </div>

</app-layout>